import { frontendURL } from 'dashboard/helper/URLHelper';

import HubpostCarsSetup from './Index.vue';

// The route NAME matters: isOnOnboardingView matches on `onboarding_`, so this
// is recognised as an onboarding view without touching the OSS helper.
export default [
  {
    path: frontendURL(
      'accounts/:accountId/onboarding/wgpt/hubpost-cars-showroom-setup'
    ),
    name: 'onboarding_wgpt_hubpost_cars_showroom_setup',
    meta: {
      permissions: ['administrator'],
    },
    component: HubpostCarsSetup,
  },
];
